const originHeaders = [
  {
    text: 'Mã số (dự kiến)',
    value: 'studentCode',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Tên học sinh',
    value: 'studentName',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Lớp',
    value: 'studentClass',
    align: 'left',
    sortable: false,
    width: 80,
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Giới tính',
    value: 'gender',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Địa chỉ hiện tại',
    value: 'address',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Họ tên Bố',
    value: 'dadName',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Họ tên Mẹ',
    value: 'momName',
    align: 'left',
    sortable: false,
  },
]
export { originHeaders }
